import { components } from 'react-select';
import { FormControl, FormLabel, RadioGroup } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import type { MenuListComponentProps } from 'react-select/lib/components/Menu';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';
import { useTranslation } from 'react-i18next';

import type { Tag } from '../types/Tag';
import TagSelectLabeledRadio from './TagSelectLabeledRadio/TagSelectLabeledRadio';
import MODES from '../constants/modes';
import type { Mode } from '../types/Mode';

const useStyles = makeStyles({
  formControl: {
    margin: '16px 16px 8px',
  },
  formLabel: {
    marginBottom: '8px',
    fontSize: '14px',
    fontWeight: '400',
    color: grayColor[16],
  },
  hr: {
    margin: '0 16px 8px',
    borderColor: grayColor[4],
  },
});

const isMode = (mode: string): mode is Mode => mode in MODES;

type MenuListPropsType = {
  selectProps: MenuListComponentProps<Tag>['selectProps'] & {
    customProps: {
      selectedTags: Tag['value'][];
      selectedMode: Mode;
      onChange: (newMode: Mode, newSelectedTags: Tag['value'][]) => void;
    };
  };
} & MenuListComponentProps<Tag>;

const MenuList = (MenuListProps: MenuListPropsType) => {
  const classes = useStyles();

  const { t } = useTranslation();

  const { customProps, ...selectPropsWithoutCustomProps } =
    MenuListProps.selectProps;
  const { selectedTags, selectedMode, onChange } = customProps;

  return (
    <div>
      <FormControl className={classes.formControl} component="fieldset">
        <FormLabel className={classes.formLabel} component="legend">
          {t('showResultsMatching')}
        </FormLabel>
        <RadioGroup
          name="mode"
          value={selectedMode}
          onChange={(_e, newMode) => {
            if (isMode(newMode)) {
              onChange(newMode, selectedTags);
            }
          }}
        >
          <TagSelectLabeledRadio
            value={MODES.or}
            label={t('atLeastOneTagCondition')}
          />
          <TagSelectLabeledRadio
            value={MODES.and}
            label={t('allTagConditions')}
          />
        </RadioGroup>
      </FormControl>
      <hr className={classes.hr} />
      <components.MenuList
        {...MenuListProps}
        selectProps={selectPropsWithoutCustomProps}
      />
    </div>
  );
};

export default MenuList;
